export const getters = {
  now: state => new Date(state.now),
};

export const actions = {
  UPDATE_NOW_DATE({ commit }) {
    commit('UPDATE_NOW_DATE', { date: new Date() });
  },
};

export const mutations = {
  UPDATE_NOW_DATE(state, { date }) {
    state.now = date;
  },
};

const state = {
  now: new Date(),
};

export default {
  state,
  actions,
  getters,
  mutations,
};
